import { post } from '../utils/api';
import localStorage from './localStorage';

const login = async (username, password) => {
  const {
    data: { data },
  } = await post('auth/v1/login', { username, password });
  localStorage.setToken(data.token);

  return data;
};

const logout = () => {
  localStorage.clearToken();
};

const output = {
  login,
  logout,
};

export default output;
